/** Integrations → Webhooks → Deliveries (PREC-4250), under `webhookHealth.deliveries`. */
export const enWebhookDeliveries = {
	title: "Deliveries",
	pageTitle: "Deliveries · {{name}}",
	integrations: "Integrations",
	webhooks: "Webhooks",
	view: "View deliveries",
	givenUpCount: "· {{count}} given up",
	new: "new",
	retention:
		"Deliveries are kept for 90 days. Deliveries before 15 Oct 2026 were not recorded, so they cannot be listed or redelivered.",
	fromTime: "From time",
	toTime: "To time",
	status: "Status",
	from: "From",
	to: "To",
	reset: "Reset filters",
	all: "All statuses",
	DELIVERED: "Delivered",
	RETRYING: "Retrying",
	QUEUED: "Retrying",
	GIVEN_UP: "Given up",
	queued: "Queued, waiting to send",
	notSent: "Not sent",
	finalAnswer: "Final answer: not retried",
	nextAttempt: "Next attempt {{date}}",
	givenUp: "Given up {{date}}",
	redelivery: "Redelivery",
	time: "Time",
	lead: "Lead",
	trigger: "Trigger",
	attempts: "Attempts",
	http: "Last HTTP status",
	excerpt: "Response excerpt",
	removed: "Lead removed",
	unknown: "Unknown",
	manual: "Manual send",
	ofSix: "{{count}} of 6",
	ofOne: "{{count}} of 1",
	details: "View delivery details",
	redeliver: "Redeliver…",
	range: "Redeliver date range…",
	failed: "Redeliver all failed ({{count}})…",
	loading: "Loading…",
	loadFailed: "Could not load deliveries. Please try again.",
	retry: "Try again",
	empty: "No deliveries recorded yet",
	emptyDescription:
		"When a lead is sent to this webhook, each delivery and what your receiver answered is listed here, and kept for 90 days.",
	emptyFiltered: "No deliveries match these filters",
	test: "Send test event",
	rows: "Rows per page",
	showing: "Showing {{from}}–{{to}} of {{count}}",
	previous: "Previous",
	next: "Next",
	close: "Close",
	cancel: "Cancel",
	delivery: "Delivery · {{name}}",
	deliveryId: "Delivery ID",
	created: "Created",
	later: "Redeliveries",
	none: "none yet",
	openLead: "Open lead",
	answer: "Answer",
	took: "Took",
	wait: "Wait",
	after: "after {{minutes}} min",
	afterHours: "after {{hours}} h",
	lastResponse: "Last response from the receiver (first 500 characters, secrets removed)",
	error: "Error",
	payload:
		"The payload is not stored. A redelivery builds it again from the lead’s current data and sends it like any other delivery of this webhook.",
	oneTitle: "Redeliver this delivery?",
	failedTitle: "Redeliver all failed deliveries?",
	rangeTitle: "Redeliver a date range",
	allDates: "all dates",
	timezone: "Times in your time zone ({{zone}})",
	which: "Which deliveries",
	givenUpOnly: "Given up only (recommended)",
	every: "Every delivery in the range, including delivered ones",
	counts_one: "{{resend}} delivery will be resent. {{skipped}} will be skipped.",
	counts_other: "{{resend}} deliveries will be resent. {{skipped}} will be skipped.",
	retryingSkip: 'Skipped: "Retrying" (a next attempt is already scheduled, it resends itself)',
	removedSkip: "Skipped: lead removed from the list or deleted",
	laterSkip: "Skipped: already delivered by a later redelivery",
	deliveredSkip: "Skipped: delivered (choose Every delivery to include them)",
	limit:
		"At most {{max}} deliveries per redelivery. Over that, choose a shorter range. Resends go out at most 5 per second.",
	overLimit:
		"{{count}} deliveries selected, at most {{max}} per redelivery. Choose a shorter range.",
	duplicateWarning:
		"It keeps the original delivery ID so your receiver can drop duplicates. Delivered deliveries are never resent by Redeliver all failed.",
	signing:
		"It uses this webhook’s current delivery settings: signed with the current secret if signing is enabled; legacy webhooks remain unsigned.",
	originalId: "Original delivery ID: {{id}}",
	retrySchedule:
		"Each redelivery is one attempt: if the receiver is still down it fails again and is retried on the normal schedule.",
	confirm_one: "Redeliver {{count}} delivery",
	confirm_other: "Redeliver {{count}} deliveries",
	invalidRange: "Choose a valid date range, with From before To.",
	previewFailed: "Could not load redelivery counts. Please try again.",
	result_one: "{{resend}} delivery sent for redelivery, {{skipped}} skipped.",
	result_other: "{{resend}} deliveries sent for redelivery, {{skipped}} skipped.",
	nothing: "Nothing was redelivered. {{reason}} No deliveries were changed.",
	paused: "The webhook is paused. Resume it to redeliver.",
	running: "A redelivery is already running ({{count}} queued). Wait for it to finish.",
	uncertain:
		"The redelivery request could not be confirmed. Refresh the deliveries before trying again.",
};
